import axios from 'axios';

// App Configuration
export const APP_CONFIG = {
  name: 'JustPlay eBGM',
  version: process.env.REACT_APP_VERSION || '2.1.0',
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  buildSha: process.env.REACT_APP_BUILD_SHA || 'local',
  isProduction: process.env.REACT_APP_ENVIRONMENT === 'production',
  isStaging: process.env.REACT_APP_ENVIRONMENT === 'staging',
  isDevelopment: !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development',
};

// API Configuration
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8787',
  timeout: 30000, // 30 seconds for file uploads
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Required for cookie-based authentication
};

// Create axios instance
export const apiClient = axios.create(API_CONFIG);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication (Better Auth endpoints)
  auth: {
    signIn: '/api/auth/sign-in/email',
    signOut: '/api/auth/sign-out',
    getSession: '/api/auth/get-session',
    me: '/api/auth/me',
  },
  
  // Content Management
  content: {
    list: '/api/content',
    recent: '/api/content/recent',
    upload: '/api/content/upload',
    detail: (id: string) => `/api/content/${id}`,
    metadata: (id: string) => `/api/content/${id}/metadata`,
    preview: (id: string) => `/api/content/${id}/preview`,
    stream: (id: string) => `/api/content/${id}/stream`,
    download: (id: string) => `/api/content/${id}/download`,
    delete: (id: string) => `/api/content/${id}`,
    approve: (id: string) => `/api/content/${id}/approve`,
    reject: (id: string) => `/api/content/${id}/reject`,
  },

  // Analytics
  analytics: {
    stats: '/api/analytics/stats',
    plays: '/api/analytics/plays',
    uploads: '/api/analytics/uploads',
    system: '/api/analytics/system',
  },

  // Settings
  settings: {
    get: '/api/settings',
    update: '/api/settings',
    apiKeys: '/api/settings/api-keys',
  },
};

// Content Upload Configuration
export const UPLOAD_CONFIG = {
  maxFileSize: 2 * 1024 * 1024 * 1024, // 2GB for large video files
  allowedTypes: [
    // Audio formats
    'audio/mpeg',
    'audio/wav',
    'audio/flac',
    'audio/aac',
    'audio/ogg',
    'audio/mp4',
    'audio/x-m4a',
    // Video formats (music videos)
    'video/mp4',
    'video/quicktime',
    'video/webm',
    'video/x-msvideo',
    'video/x-matroska',
    'video/mpeg',
    'video/x-m4v',
  ],
  allowedExtensions: [
    // Audio
    '.mp3', '.wav', '.flac', '.aac', '.ogg', '.m4a',
    // Video
    '.mp4', '.mov', '.webm', '.avi', '.mkv', '.m4v',
  ],
};